import { React, useState, useEffect } from "react";

import CustomSelect from "components/common/select/SelectField";
import Activity from "../activities/Activity";
import SearchableSelect from "components/common/searchableSelect/SearchableSelect";
import {
  bankId,
  bankProducts,
  bGId,
  getIcon,
  ROLES,
} from "common/constants/constants";

import "./Activity.scss";
import { getAllBankslist } from "services/bankServices";
import { getAllBranchesNames } from "services/bankServices";
import { Row, Col } from "react-bootstrap";
import { getProductList } from "services/ProductsServices";
import {
  getApplicationKeysFromStorage,
  getMatchedProducts,
  getUserRoleFromStorage,
  IsAllProductsAssigned,
} from "common/utils/utilities";
import Loader from "components/common/loader/Loader";
import { useTranslation } from "react-i18next";

const ActivityActionBar = () => {
  const { t } = useTranslation();
  const branchAllProducts = [
    { value: 1, name: t("all-products") },
    { value: 2, name: "Gecco" },
    { value: 3, name: "FutureCare" },
  ];
  const [selectedProduct, setSelectedPrdouct] = useState(1);
  const bankGroupId = bGId;
  const [bankList, setBankList] = useState([]);
  const [branchList, setBranchList] = useState([]);
  const [loader, setLoader] = useState(true);
  const [products, setProducts] = useState([]);
  const [filters, setFilters] = useState({
    bankId: "",
    branchId: "",
  });

  const handleChange = (e) => {
    setSelectedPrdouct(e.product);
  };
  const getBanksList = async () => {
    let result = await getAllBankslist(bankGroupId);
    if (result?.success) {
      let list = result?.payLoad?.map((item) => {
        return { value: item.bankId, name: item.bankName };
      });
      setBankList(list);
    }
  };
  const getBranchesNames = async () => {
    let result = await getAllBranchesNames(bankGroupId, filters.bankId);
    if (result?.success) {
      let list = result?.payLoad?.map((item) => {
        return {
          value: item.branchId,
          name: item.branchName,
          products: item.products,
        };
      });
      if (!list.length) {
        setFilters((pre) => {
          return { ...pre, branchId: "0000-0000-0000" };
        });
      }
      setBranchList(list);
    }
  };
  useEffect(() => {
    getBanksList();
  }, []);

  useEffect(() => {
    if (filters.bankId) {
      getBranchesNames();
    } else {
      setBranchList([]);
      setFilters({
        bankId: "",
        branchId: "",
      });
    }
  }, [filters.bankId]);

  const compairBranchProduts = (orignal, compair) => {
    if (orignal.length === compair.length) {
      return compair.every((elem, index) => {
        if (orignal.indexOf(elem) > -1) {
          return true;
        }
        return false;
      });
    } else return false;
  };
  useEffect(() => {
    let productsArr = [];
    const { branchId } = filters;
    if (branchId) {
      const branch = branchList.find((branch) => branch.value === branchId);
      const { products = [] } = branch || {};
      products.forEach((product) => {
        productsArr = [...productsArr, product.productKey];
      });
    }
    if (compairBranchProduts(["#Gecco", "#FutureCare"], productsArr)) {
      setSelectedPrdouct(1);
    } else if (compairBranchProduts(["#FutureCare"], productsArr)) {
      setSelectedPrdouct(3);
    } else if (compairBranchProduts(["#Gecco"], productsArr)) {
      setSelectedPrdouct(2);
    }
  }, [filters.branchId]);

  const handleFilterChange = (key, value) => {
    if (key === "bankId") {
      setFilters((pre) => {
        return { ...pre, bankId: value };
      });
    } else {
      setFilters((pre) => {
        return { ...pre, branchId: value };
      });
    }
  };
  const getProductsList = async () => {
    try {
      if (getUserRoleFromStorage()?.roleName === ROLES.branch_admin) {
        const result = await getProductList();
        if (result?.success) {
          const tempProducts = IsAllProductsAssigned(
            result.payLoad.items.filter(
              (item) => item?.statusTranslatedValue?.toLowerCase() === "active"
            )
          )
            ? [{ value: 1, name: t("all-products") }, ...bankProducts]
            : getMatchedProducts(
                result.payLoad.items.filter((item) => {
                  return (
                    item?.statusTranslatedValue?.toLowerCase() === "active"
                  );
                })
              ) || [];

          setProducts(tempProducts);
          setSelectedPrdouct(tempProducts[0]?.value);
        } else {
          setProducts(branchAllProducts);
          setSelectedPrdouct(1);
        }
      } else if (
        getUserRoleFromStorage()?.roleName === ROLES.branch_consultant
      ) {
        const keys = getApplicationKeysFromStorage();
        if (keys.length) {
          handleBranchProducts();
        } else {
          setProducts([]);
          setSelectedPrdouct(-1);
        }
      } else {
        setProducts(branchAllProducts);
        setSelectedPrdouct(1);
      }
    } catch (e) {
      console.log(e);
    } finally {
      setLoader(false);
    }
  };
  const handleBranchProducts = () => {
    const tempProducts = bankProducts.filter((item) =>
      keys.includes("#" + item.name.replaceAll(" ", ""))
    );
    setProducts(tempProducts?.length === 2 ? branchAllProducts : tempProducts);
    setSelectedPrdouct(tempProducts?.length === 2 ? 1 : tempProducts[0].value);
  };
  useEffect(() => {
    getProductsList();
  }, []);

  return (
    <>
      {loader ? (
        <Loader height={"200px"} />
      ) : (
        <>
          <div className="maindiv d-flex align-items-end mt-3">
            <Row className="activityBar d-flex w-100">
              <Col lg={3} md={12} xs={12}>
                <CustomSelect
                  name={"product"}
                  handleChange={handleChange}
                  handleSubmit={() => {}}
                  list={products}
                  size="md"
                  width="150px"
                  height="40px"
                  padding="0 5px"
                  display="flex"
                  alignItems="center"
                />
              </Col>
              <Col lg={6} md={12} xs={12}>
                {JSON.parse(
                  localStorage.getItem("userRole")
                )?.roleName?.includes("IA") && (
                  <Row>
                    <Col lg={6} md={12} xs={12}>
                      <SearchableSelect
                        placeholder={t("all-banks")}
                        name="bankId"
                        options={bankList.map((bank) => {
                          return { value: bank.value, label: bank.name };
                        })}
                        handleChange={(key, value) =>
                          handleFilterChange(key, value)
                        }
                        value={filters?.bankId}
                      />
                    </Col>
                    <Col lg={6} md={12} xs={12}>
                      <SearchableSelect
                        placeholder={t("all-branches")}
                        name="branchId"
                        options={branchList.map((branch) => {
                          return {
                            value: branch.value,
                            label: branch.name,
                          };
                        })}
                        handleChange={(key, value) =>
                          handleFilterChange(key, value)
                        }
                        isDisabled={branchList.length > 0 ? false : true}
                        value={filters?.branchId}
                      />
                    </Col>
                  </Row>
                )}
              </Col>
            </Row>
          </div>
          <Activity
            selectedProduct={selectedProduct}
            filters={filters}
            branchList={branchList}
          />
        </>
      )}
    </>
  );
};

export default ActivityActionBar;
